import { render, staticRenderFns } from "./DHME.WKB.RiskAnalysis.vue?vue&type=template&id=22c5b08f&scoped=true"
import script from "./DHME.WKB.RiskAnalysis.vue?vue&type=script&lang=js"
export * from "./DHME.WKB.RiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DHME.WKB.RiskAnalysis.vue?vue&type=style&index=0&id=22c5b08f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5b08f",
  null
  
)

export default component.exports